'use server';

import { ai } from '@/ai/genkit';
import { z } from 'genkit';

const CarServiceSuggestionsInputSchema = z.object({
  problemDescription: z.string(),
});
export type CarServiceSuggestionsInput = z.infer<typeof CarServiceSuggestionsInputSchema>;

const CarServiceSuggestionsOutputSchema = z.object({
  suggestedServices: z.array(z.string()),
  suggestedWorkshops: z.array(z.string()),
});
export type CarServiceSuggestionsOutput = z.infer<typeof CarServiceSuggestionsOutputSchema>;

export async function carServiceSuggestions(input: CarServiceSuggestionsInput): Promise<CarServiceSuggestionsOutput> {
  return carServiceSuggestionsFlow(input);
}

const prompt = ai.definePrompt({
  name: 'carServiceSuggestionsPrompt',
  input: { schema: CarServiceSuggestionsInputSchema },
  output: { schema: CarServiceSuggestionsOutputSchema },
  prompt: `خبير صيانة سيارات. المشكلة: {{{problemDescription}}}
اقترح 3 خدمات و2 أنواع ورش مناسبة كقوائم نصية قصيرة.`,
  config: { maxOutputTokens: 200 },
});

const carServiceSuggestionsFlow = ai.defineFlow(
  {
    name: 'carServiceSuggestionsFlow',
    inputSchema: CarServiceSuggestionsInputSchema,
    outputSchema: CarServiceSuggestionsOutputSchema,
  },
  async input => {
    const { output } = await prompt(input);
    return output!;
  }
);
